import DigitalGallery from '../../components/DigitalGallery';
import BaseView from './BaseView';

let view = null;

class GalleryView extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		const gallery = this.container.querySelector('[data-digital-gallery]');

		if (gallery) {
			this.components.push(new DigitalGallery(gallery));
		}
	}

	destroy() {
		super.destroy();
	}
}

export default {
	namespace: 'template-gallery',
	beforeEnter: ({ current, next, trigger }) => {
		view = new GalleryView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
